<m-new-session *ngIf="showContent" class="h-full w-full"></m-new-session>
<div *ngIf="showContent$ | async"></div>
